<template>
  <section class="templates">
    <slot name="before"></slot>
    <section class="template-list">
      <Swiper
        class="swiper"
        :options="options"
      >
        <SwiperSlide
          v-for="template in templates"
          :key="template.id"
        >
          <TemplateCardBasic
            size="sm"
            class="template-panel__card-item"
            :presentation="template"
            templateLocation="top panel"
          />
        </SwiperSlide>
        <SwiperSlide v-if="showBrowseAll">
          <TemplateCardBasic
            class="template-panel__card-item"
            :presentation="{
              name: term_BrowseAll,
            }"
            :custom-handler="handleBrowseAllClick"
          >
            <template slot="thumbnail">
              <div
                class="template-thumbnail"
              >
                <img
                  class="object-cover w-full h-full rounded"
                  :src="require('@/assets/images/browseall.svg')"
                  alt="Thumbnail default"
                />
                <div class="browser__hover"></div>
              </div>
            </template>
          </TemplateCardBasic>
        </SwiperSlide>
        <div class="swiper-nav-button next-template-btn" slot="button-next">
          <aha-icon
            name="chevron-right-2"
            width="8"
            viewBox="0 0 8 14"
          />
        </div>
        <div class="swiper-nav-button prev-template-btn" slot="button-prev">
          <aha-icon
            name="chevron-right-2"
            width="8"
            viewBox="0 0 8 14"
            class="transform rotate-180"
          />
        </div>
      </Swiper>
    </section>
    <slot name="after"></slot>
  </section>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import TemplateCardBasic from '@/components-v2/common/template-library/TemplateCardBasic.vue'
import 'swiper/css/swiper.css'

export default {
  components: {
    TemplateCardBasic,
    Swiper,
    SwiperSlide,
  },
  props: {
    templates: {
      type: Array,
      default: () => [],
    },
    showBrowseAll: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      options: {
        observer: true,
        observeParents: true,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        noSwiping: false,
        cssMode: false,
        mousewheel: {
          forceToAxis: true,
        },
        spaceBetween: 16,
        navigation: {
          nextEl: '.next-template-btn',
          prevEl: '.prev-template-btn',
        },
        breakpoints: {
          768: {
            slidesPerGroup: 2,
          },
          960: {
            slidesPerGroup: 3,
          },
        },
      },
    }
  },
  computed: {
    term_BrowseAll() {
      return this.$i18nPresenter.t('Browse all')
    },
  },
  methods: {
    handleBrowseAllClick() {
      this.$emit('browse-all-click')
    },
  },
}
</script>
<style lang="scss" scoped>
    .templates {
        @apply rounded-lg shadow-card;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        background-color: white;
        padding: 1rem;

        & .swiper-slide {
          width: 130px;
        }

        & > .template-list {
          &::v-deep {
            & .template-card {
              max-width: 130px;
            }

            & .template-thumbnail {
              width: 130px;
              height: 76px;
            }
          }

          & .swiper-nav-button {
            --top-align: 20%;
            --padding-space: 0.5rem;
            position: absolute;
            z-index: 1;
            top: var(--top-align);

            &.swiper-button-disabled {
              display: none;
            }

            &.prev-template-btn {
              left: var(--padding-space);
            }

            &.next-template-btn {
              right: var(--padding-space);
            }
          }
        }
    }
</style>
